// Простые и рабочие анимации для Chart.js v2
export const chartAnimations = {
  // Плавная анимация (по умолчанию)
  smooth: {
    duration: 1200,
    easing: 'easeInOutQuart'
  },

  // Быстрая анимация
  fast: {
    duration: 600,
    easing: 'easeOutQuart'
  },

  // Медленная анимация
  slow: {
    duration: 2000,
    easing: 'easeInOutSine'
  },

  // Эластичная анимация (с отскоком)
  bounce: {
    duration: 1500,
    easing: 'easeInOutBounce'
  },

  // Пружинная анимация
  elastic: {
    duration: 1800,
    easing: 'easeInOutElastic'
  },

  // Резкая анимация
  sharp: {
    duration: 800,
    easing: 'easeInOutCubic'
  },

  // Волнообразная анимация
  wave: {
    duration: 1600,
    easing: 'easeInOutSine'
  },

  // Поэтапная анимация (имитация через длительность)
  staggered: {
    duration: 2500,
    easing: 'easeOutQuart'
  },

  // Поэтапная анимация слева направо
  staggeredLeftToRight: {
    duration: 2200,
    easing: 'easeOutQuart'
  },

  // Поэтапная анимация по датасетам
  staggeredByDataset: {
    duration: 2800,
    easing: 'easeOutQuart'
  },

  // Поэтапная анимация с волной
  staggeredWave: {
    duration: 2400,
    easing: 'easeInOutSine'
  },

  // Анимация "из центра"
  center: {
    duration: 1400,
    easing: 'easeOutBack'
  },

  // Анимация "снизу вверх"
  bottomUp: {
    duration: 1300,
    easing: 'easeOutQuart'
  },

  // Дополнительные анимации для Chart.js v2
  // Поэтапная симуляция
  staggeredSimulated: {
    duration: 3000,
    easing: 'easeOutQuart'
  },

  // Анимация с паузами
  staggeredPause: {
    duration: 2500,
    easing: 'easeInOutQuart'
  },

  // Каскадная анимация
  cascade: {
    duration: 2600,
    easing: 'easeOutCubic'
  },

  // Волновой эффект
  waveEffect: {
    duration: 2200,
    easing: 'easeInOutSine'
  }
};

// Функция для получения настроек анимации
export function getAnimationConfig(animationType = 'smooth') {
  return chartAnimations[animationType] || chartAnimations.smooth;
}

// Функция для создания полных настроек анимации с элементами
export function createAnimationOptions(animationType = 'smooth', chartType = 'line') {
  const animationConfig = getAnimationConfig(animationType);
  
  const baseOptions = {
    animation: {
      ...animationConfig,
      onProgress: function(animation) {
        // Дополнительные эффекты для разных типов анимаций
        if (animationType.includes('staggered') || animationType === 'cascade' || animationType === 'waveEffect') {
          // Имитируем поэтапную анимацию через прогресс
          const progress = animation.animationObject.currentStep / animation.animationObject.numSteps;
          // Можно добавить дополнительные эффекты здесь
        }
      },
      onComplete: function(animation) {
        // Эффекты при завершении анимации
        if (animationType === 'bounce' || animationType === 'elastic') {
          // Дополнительные эффекты для эластичных анимаций
        }
      }
    }
  };

  // Настройки элементов в зависимости от типа графика
  if (chartType === 'line') {
    baseOptions.elements = {
      line: {
        tension: animationType === 'wave' || animationType === 'waveEffect' ? 0.6 : 0.4,
        borderWidth: animationType === 'sharp' ? 4 : 3
      },
      point: {
        // Не переопределяем radius, если он уже задан в опциях
        hoverRadius: animationType === 'bounce' ? 12 : 8,
        borderWidth: 2
      }
    };
  } else if (chartType === 'bubble') {
    baseOptions.elements = {
      point: {
        radius: animationType === 'bounce' ? 10 : 8,
        hoverRadius: animationType === 'bounce' ? 15 : 12,
        borderWidth: 2
      }
    };
  }

  return baseOptions;
}

// Список доступных анимаций для UI
export const availableAnimations = [
  { key: 'smooth', name: 'Плавная', description: 'Стандартная плавная анимация (1200ms)' },
  { key: 'fast', name: 'Быстрая', description: 'Быстрое появление (600ms)' },
  { key: 'slow', name: 'Медленная', description: 'Медленное плавное появление (2000ms)' },
  { key: 'bounce', name: 'Эластичная', description: 'Анимация с отскоком (1500ms)' },
  { key: 'elastic', name: 'Пружинная', description: 'Пружинный эффект (1800ms)' },
  { key: 'sharp', name: 'Резкая', description: 'Быстрая резкая анимация (800ms)' },
  { key: 'wave', name: 'Волнообразная', description: 'Плавные волны (1600ms)' },
  { key: 'staggered', name: 'Поэтапная', description: 'Имитация поэтапного появления (2500ms)' },
  { key: 'staggeredLeftToRight', name: 'Слева направо', description: 'Имитация слева направо (2200ms)' },
  { key: 'staggeredByDataset', name: 'По датасетам', description: 'Имитация по датасетам (2800ms)' },
  { key: 'staggeredWave', name: 'Волновая поэтапная', description: 'Имитация волнового эффекта (2400ms)' },
  { key: 'center', name: 'Из центра', description: 'Появление из центра (1400ms)' },
  { key: 'bottomUp', name: 'Снизу вверх', description: 'Появление снизу (1300ms)' },
  { key: 'staggeredSimulated', name: 'Поэтапная симуляция', description: 'Улучшенная имитация поэтапности (3000ms)' },
  { key: 'staggeredPause', name: 'С паузами', description: 'Анимация с паузами (2500ms)' },
  { key: 'cascade', name: 'Каскад', description: 'Каскадное появление (2600ms)' },
  { key: 'waveEffect', name: 'Волновой эффект', description: 'Волновой эффект (2200ms)' }
];